import { ReactNode } from 'react';
import { Box, Paper, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { cardSurface } from './surfaces';

interface KpiCardProps {
  label: string;
  help?: ReactNode;
  children: ReactNode;
  /** Short qualifier for the whole card, e.g. an "Estimación" chip. */
  badge?: ReactNode;
  caption?: ReactNode;
  action?: ReactNode;
}

export const KpiCard = ({ label, help, children, badge, caption, action }: KpiCardProps) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      ...cardSurface,
    }}
  >
    <Box
      display="flex"
      alignItems="flex-start"
      justifyContent="space-between"
      gap={1}
      mb={1}
      sx={{ minHeight: 34 }}
    >
      <Typography
        variant="overline"
        color="text.secondary"
        lineHeight={1.4}
        sx={{ letterSpacing: '0.06em' }}
      >
        {label}
        {help ? (
          <Tooltip title={help} arrow>
            <InfoOutlinedIcon
              fontSize="inherit"
              sx={{ ml: 0.5, color: 'text.secondary', cursor: 'help', verticalAlign: 'middle' }}
            />
          </Tooltip>
        ) : null}
      </Typography>
      {badge ? <Box sx={{ flexShrink: 0, mt: 0.25 }}>{badge}</Box> : null}
    </Box>

    <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 44 }}>{children}</Box>

    {caption ? (
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.75, lineHeight: 1.5 }}>
        {caption}
      </Typography>
    ) : null}
    {action ? <Box sx={{ mt: 'auto', pt: 1 }}>{action}</Box> : null}
  </Paper>
);
